import appStore from '../assets/img/DownloadOnAppStore.svg';

export const DownloadOnAppStore = () => {
    return (
        <div onClick={() => {
            window.open('https://apps.apple.com/us/app/obsessless-ocd-treatment-app/id6742539895', '_blank');
        }}>
            <img src={appStore} alt="App Store" className="w-full h-full object-contain" />
        </div>
    );
};
